<template>
    <div class="home">
        <Navbar showSearchButton></Navbar>

        <div>
            <!-- poveznice -->
            <div class="poveznice">
                <Poveznice></Poveznice>
            </div>

            <!-- counters -->
            <div class="container">

                <PanelPokreni v-if="appState == 'round-in-progress'"/>

                <div class="counter-divs cf">
                    <div class="counter"  v-if="appState == 'round-starting'">
                        <UntilNextRoundCounter></UntilNextRoundCounter>
                    </div>
                    <div class="score">
                        <PrevRoundScore  v-if="appState != 'round-in-progress'"></PrevRoundScore>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="slider">
                <transition name="fade-translate" appear>
                    <SliderHelp></SliderHelp>
                </transition>
            </div>
        </div>

        <a @click="sendGA('Povratak na portal')" href="https://www.tonimilun.hr" class="button-1 dark-blue portal">Povratak na portal</a>

        <Partneri></Partneri>

    </div>
</template>

<script>
import Navbar from '../components/Navbar'
import Poveznice from '../components/Poveznice'
import SliderHelp from '../components/SliderHelp'
import Partneri from '../components/Partneri'
import PanelPokreni from '../components/PanelPokreni'
import UntilNextRoundCounter from '../components/UntilNextRoundCounter'
import PrevRoundScore from '../components/PrevRoundScore'

export default {
    name: 'home',
    data: function () {
        return {
            round: this.$store.getters.round
        }
    },
    computed: {
        appState () {
            return this.$store.state.appState
        }
    },
    methods: {
        resetFirebaseQuiz (inSeconds, quizId, perQuestion) {
            this.$db.debug.resetFirebaseQuiz(inSeconds, quizId, perQuestion)
        },
        goToTurnIn () {
            this.$router.push({ name: 'prijava' })
        },
        sendGA (button) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Home',
                'event_label': `${button}`
            })
        }
    },
    components: {
        Navbar,
        Poveznice,
        SliderHelp,
        Partneri,
        UntilNextRoundCounter,
        PanelPokreni,
        PrevRoundScore
    },
    mounted: function () {
        window.app = this
    }
}
</script>

<style lang="scss" scoped>
.home {
    overflow: hidden;
    padding-bottom: 40px;

    .counter-divs {
        margin-bottom: 30px;
    }
    .poveznice {
        margin-bottom: 30px;
    }
    .slider {
        margin-bottom: 40px;
    }
    .panel-pokreni {
        margin-bottom: 50px;
    }
    .portal {
        padding: 11px 15px;
    }
    .partner-section {
        margin-top: 40px;
    }
}

.counter-divs {
    font-family: "mPlus";
    text-align: left;
    margin-left: -24px;
    font-size: 14px;
    letter-spacing: -.2px;
    display: flex;

    > div {
        width: 100%;
        float: left;
        padding-left: 24px;
    }
    .score {
        div {
            box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
            padding: 16px 14px 14px;
            background-color: #fff;
            color: #000;
            border-radius: 10px;
            height: 100%;

            span {
                text-align: center;
                font-family: "axiforma";
                text-transform: uppercase;
                font-size: 10px;
                letter-spacing: 1px;
                color: #adadae;
                margin-top: 10px;
            }
            b {
                display: block;
                font-family: "mPlus";
                font-size: 18px;
                line-height: 26px;
                letter-spacing: -.2px;
                color: #000;
            }
            i {
                display: block;
                color: #fff;
                background-color: #12385d;
                border-radius: 6px;
                padding: 5px 0px;
                font-size: 10px;
                margin-bottom: 6px;
            }
            span:nth-child(1) {
                float: left;
            }
            span:nth-child(2) {
                float: right;
            }
        }
    }
}

@media only screen and (min-width: 800px) {
    .home {
        max-width: 1180px;
        margin: auto;
        > div:nth-child(2) {
            display: flex;
            justify-content: space-between;
        }
        .counter-divs {
            margin: 0;
        }
        .poveznice {
            text-align: left;
            margin: 0;
        }
        .slider {
            max-width: 900px;
            margin: 40px auto;
        }
    }
}
@media only screen and (max-width: 380px) {
    .home {
        .counter-divs {
            font-size: 10px;
        }
    }
}
</style>
